<template>
  <div class="home">
    
    <Navbar data-aos="flip-down"/>

    <Banner data-aos="flip-up"/>

    <!-- <Feature data-aos="flip-up"/> -->

    <Content />

    <Footer data-aos="flip-up"/>
    
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from '@/views/Navbar.vue'
import Banner from '@/views/Banner.vue'
import Feature from '@/views/Feature.vue'
import Content from '@/views/Content.vue'
import Footer from '@/views/Footer.vue'

export default {
  name: 'home',
  components: {
    Navbar,
    Banner,
    Feature,
    Content,
    Footer,
  }
}
</script>
